import { render, staticRenderFns } from "./station.vue?vue&type=template&id=6fd966d6&scoped=true&"
import script from "./station.vue?vue&type=script&lang=ts&"
export * from "./station.vue?vue&type=script&lang=ts&"
import style0 from "./station.vue?vue&type=style&index=0&id=6fd966d6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd966d6",
  null
  
)

export default component.exports